// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"83aec2c8","453":"da691771","455":"35639fee","701":"3d24fda3"}[chunkId] + ".chunk.js";
};